(function () {
  'use strict';

  if (!window.Shopify || !window.Shopify.theme || !window.Shopify.theme.PredictiveSearchComponent) {
    return;
  }

  var PredictiveSearch = window.Shopify.theme.PredictiveSearch;
  var OriginalComponent = window.Shopify.theme.PredictiveSearchComponent;
  var componentProto = OriginalComponent.prototype;

  var KRONOTIME_API_CONFIG = {
    resources: {
      type: ['query', 'collection', 'product'],
      limit: 10,
      limit_scope: 'each',
      options: {
        unavailable_products: PredictiveSearch.UNAVAILABLE_PRODUCTS.LAST,
        fields: [
          PredictiveSearch.FIELDS.TITLE,
          PredictiveSearch.FIELDS.VENDOR,
          PredictiveSearch.FIELDS.PRODUCT_TYPE,
          PredictiveSearch.FIELDS.TAG,
          PredictiveSearch.FIELDS.VARIANTS_TITLE,
          PredictiveSearch.FIELDS.VARIANTS_SKU,
          PredictiveSearch.FIELDS.VARIANTS_BARCODE
        ]
      }
    }
  };

  var strings = {
    suggestions: 'Sugerencias',
    collections: 'Colecciones',
    products: 'Productos',
    viewAll: 'Ver todos los productos',
    loading: 'Cargando',
    noResults: 'No se encontraron resultados. Intenta con otras palabras, SKU o código de barras.'
  };

  if (window.theme && window.theme.strings) {
    strings.suggestions = window.theme.strings.searchSuggestions || strings.suggestions;
    strings.collections = window.theme.strings.searchCollections || strings.collections;
    strings.products = window.theme.strings.products || strings.products;
    strings.viewAll = window.theme.strings.searchViewAllProducts || strings.viewAll;
    strings.loading = window.theme.strings.loading || strings.loading;
    strings.noResults = window.theme.strings.searchNoResults || strings.noResults;
    strings.noResultsHeading = window.theme.strings.searchNoResultsHeading || 'No se encontraron resultados';
    strings.noResultsCollectionLink = window.theme.strings.searchNoResultsCollectionLink || 'Ver colección';
  }

  var noResultsConfigCache = null;

  function getNoResultsConfig() {
    if (noResultsConfigCache) return noResultsConfigCache;

    var configElement = document.getElementById('PredictiveSearchNoResultsConfig');
    if (!configElement) {
      noResultsConfigCache = {};
      return noResultsConfigCache;
    }

    try {
      noResultsConfigCache = JSON.parse(configElement.textContent);
    } catch (error) {
      noResultsConfigCache = {};
    }

    return noResultsConfigCache;
  }

  function hasSearchResults(data) {
    return Boolean(
      (data.products && data.products.length) ||
        (data.queries && data.queries.length) ||
        (data.collections && data.collections.length)
    );
  }

  function escapeHtml(input) {
    return String(input || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function formatMoney(cents) {
    if (window.theme && window.theme.Currency) {
      return theme.Currency.formatMoney(cents, theme.moneyFormat);
    }
    return cents;
  }

  function getProductImage(product) {
    var featured = null;

    if (product.variants && product.variants.length && product.variants[0].featured_image) {
      featured = product.variants[0].featured_image;
    } else if (product.featured_image) {
      featured = product.featured_image;
    }

    if (!featured) return null;

    var url = featured.url;
    if (window.theme && window.theme.Images) {
      url = theme.Images.getSizedImageUrl(url, '360x');
    }

    return {
      url: url,
      alt: featured.alt || product.title
    };
  }

  function getDiscountPercent(product) {
    if (!product.compare_at_price_min || product.compare_at_price_min <= product.price_min) {
      return 0;
    }

    return Math.round(
      ((product.compare_at_price_min - product.price_min) * 100) / product.compare_at_price_min
    );
  }

  function normalizeProduct(product) {
    var variant = product.variants && product.variants.length ? product.variants[0] : product;
    var isOnSale =
      product.compare_at_price_min !== null &&
      parseInt(product.compare_at_price_min, 10) > parseInt(product.price_min, 10);

    return {
      url: variant.url || product.url,
      image: getProductImage(product),
      title: product.title,
      vendor: product.vendor || '',
      price: formatMoney(product.price_min),
      compareAtPrice: formatMoney(product.compare_at_price_min),
      available: product.available,
      isOnSale: isOnSale,
      isPriceVaries: product.price_max !== product.price_min,
      discount: getDiscountPercent(product)
    };
  }

  function buildSearchUrl(query) {
    var base = '/search';
    var input = document.querySelector('[data-predictive-search-drawer-input]');
    if (input && input.dataset.baseUrl) {
      base = input.dataset.baseUrl;
    }
    return base + '?q=' + encodeURIComponent(query) + '&options%5Bprefix%5D=last';
  }

  function renderSuggestions(items) {
    if (!items.length) return '';

    return [
      '<div class="predictive-search-kronotime__group">',
      '<p class="predictive-search-kronotime__group-title">' + escapeHtml(strings.suggestions) + '</p>',
      '<ul class="predictive-search-kronotime__list" role="listbox">',
      items
        .map(function (item, index) {
          return (
            '<li class="predictive-search-kronotime__list-item" role="option" data-search-result id="search-suggestion-' +
            index +
            '">' +
            '<a class="predictive-search-kronotime__list-link" href="' +
            escapeHtml(item.url) +
            '" tabindex="-1">' +
            escapeHtml(item.text) +
            '</a></li>'
          );
        })
        .join(''),
      '</ul>',
      '</div>'
    ].join('');
  }

  function renderCollections(collections) {
    if (!collections.length) return '';

    return [
      '<div class="predictive-search-kronotime__group">',
      '<p class="predictive-search-kronotime__group-title">' + escapeHtml(strings.collections) + '</p>',
      '<ul class="predictive-search-kronotime__list" role="listbox">',
      collections
        .map(function (collection, index) {
          return (
            '<li class="predictive-search-kronotime__list-item" role="option" data-search-result id="search-collection-' +
            index +
            '">' +
            '<a class="predictive-search-kronotime__list-link" href="' +
            escapeHtml(collection.url) +
            '" tabindex="-1">' +
            escapeHtml(collection.title) +
            '</a></li>'
          );
        })
        .join(''),
      '</ul>',
      '</div>'
    ].join('');
  }

  function renderPriceListing(product) {
    if (!window.theme || !window.theme.settings || !window.theme.settings.predictiveSearchShowPrice) {
      return '';
    }

    var priceClass = 'price price--listing';
    if (!product.available) priceClass += ' price--sold-out';
    if (product.isOnSale) priceClass += ' price--on-sale';

    var vendorMarkup = '';
    if (window.theme.settings.predictiveSearchShowVendor && product.vendor) {
      vendorMarkup =
        '<div class="price__vendor price__vendor--listing">' +
        '<dt><span class="visually-hidden">Vendor</span></dt>' +
        '<dd>' +
        escapeHtml(product.vendor) +
        '</dd></div>';
    }

    if (product.isOnSale) {
      return [
        '<dl class="' + priceClass + '">',
        vendorMarkup,
        '<div class="price__regular">',
        '<dt><span class="visually-hidden">Regular price</span></dt>',
        '<dd><span class="price-item price-item--regular">' + escapeHtml(product.price) + '</span></dd>',
        '</div>',
        '<div class="price__sale">',
        '<dt><span class="visually-hidden">Sale price</span></dt>',
        '<dd><span class="price-item price-item--sale">AHORA <span>' + escapeHtml(product.price) + '</span></span></dd>',
        '<div class="price__compare">',
        '<dt><span class="visually-hidden">Regular price</span></dt>',
        '<dd><s class="price-item price-item--regular">ANTES <span>' + escapeHtml(product.compareAtPrice) + '</span></s></dd>',
        '</div>',
        '</div>',
        '</dl>'
      ].join('');
    }

    return [
      '<dl class="' + priceClass + '">',
      vendorMarkup,
      '<div class="price__regular">',
      '<dt><span class="visually-hidden">Regular price</span></dt>',
      '<dd><span class="price-item price-item--regular">' + escapeHtml(product.price) + '</span></dd>',
      '</div>',
      '</dl>'
    ].join('');
  }

  function renderProductCard(product, index, total) {
    var imageMarkup = product.image
      ? '<img class="grid-view-item__image lazyload" src="' +
        escapeHtml(product.image.url) +
        '" data-src="' +
        escapeHtml(product.image.url) +
        '" alt="' +
        escapeHtml(product.image.alt) +
        '" loading="lazy" data-image />'
      : '';

    var discountMarkup =
      product.discount > 0
        ? '<div class="top-right"><p>' + product.discount + '%</p></div>'
        : '';

    var soldOutClass = product.available ? '' : ' grid-view-item--sold-out';

    return [
      '<li class="grid__item small--one-half medium-up--one-fifth predictive-search-kronotime__grid-item" role="option" data-search-result id="search-result-' +
        index +
        '">',
      '<div class="grid-view-item' + soldOutClass + ' product-card">',
      '<a class="grid-view-item__link grid-view-item__image-container full-width-link" href="' +
        escapeHtml(product.url) +
        '" tabindex="-1">',
      '<span class="visually-hidden">' + escapeHtml(product.title) + '</span>',
      '</a>',
      '<div class="product-card__image-with-placeholder-wrapper" data-image-loading-animation>',
      discountMarkup,
      '<div class="grid-view-item__image-wrapper product-card__image-wrapper js">',
      '<div class="grid-view-item__image-box">',
      imageMarkup,
      '</div>',
      '</div>',
      '</div>',
      '<div class="h4 grid-view-item__title product-card__title" aria-hidden="true">' + escapeHtml(product.title) + '</div>',
      renderPriceListing(product),
      '<span class="visually-hidden">' + (index + 1) + ' de ' + total + '</span>',
      '</div>',
      '</li>'
    ].join('');
  }

  function renderProducts(products, searchQuery, options) {
    options = options || {};
    var sectionTitle = options.sectionTitle || strings.products;
    var viewAllUrl = options.viewAllUrl || (searchQuery ? buildSearchUrl(searchQuery) : '');
    var viewAllLabel = options.viewAllLabel || strings.viewAll;

    if (!products.length && !searchQuery && !options.forceRender) return '';

    var normalized = products.map(normalizeProduct);

    return [
      '<div class="predictive-search-kronotime__products">',
      '<div class="predictive-search-kronotime__products-header">',
      '<p class="predictive-search-kronotime__group-title" id="predictive-search">' +
        escapeHtml(sectionTitle) +
        '</p>',
      viewAllUrl
        ? '<a class="predictive-search-kronotime__view-all" href="' +
          escapeHtml(viewAllUrl) +
          '">' +
          escapeHtml(viewAllLabel) +
          '</a>'
        : '',
      '</div>',
      normalized.length
        ? [
            '<ul id="predictive-search-results" class="grid grid--uniform grid--view-items predictive-search-kronotime__product-grid" role="listbox" aria-labelledby="predictive-search">',
            normalized
              .map(function (product, index) {
                return renderProductCard(product, index, normalized.length);
              })
              .join(''),
            '</ul>'
          ].join('')
        : '<p class="predictive-search-kronotime__empty">' + escapeHtml(strings.noResults) + '</p>',
      '</div>'
    ].join('');
  }

  function renderNoResultsState(searchQuery) {
    var config = getNoResultsConfig();
    var heading = config.heading || strings.noResultsHeading;
    var message = config.message || strings.noResults;
    var showCollection = config.showCollection !== false;
    var fallbackProducts = showCollection && config.products ? config.products : [];
    var collectionTitle = config.collectionTitle || strings.products;
    var collectionUrl = config.collectionUrl || '';
    var collectionLinkLabel = config.collectionLinkLabel || strings.noResultsCollectionLink;
    var productsMarkup = '';

    if (fallbackProducts.length) {
      productsMarkup = renderProducts(fallbackProducts, '', {
        sectionTitle: collectionTitle,
        viewAllUrl: collectionUrl,
        viewAllLabel: collectionLinkLabel,
        forceRender: true
      });
    }

    return [
      '<div class="predictive-search-kronotime predictive-search-kronotime--no-results">',
      '<div class="predictive-search-kronotime__no-results-message">',
      heading
        ? '<p class="predictive-search-kronotime__no-results-heading">' + escapeHtml(heading) + '</p>'
        : '',
      '<p class="predictive-search-kronotime__empty">' + escapeHtml(message) + '</p>',
      searchQuery
        ? '<p class="predictive-search-kronotime__no-results-query">' +
          escapeHtml('“') +
          escapeHtml(searchQuery) +
          escapeHtml('”') +
          '</p>'
        : '',
      '</div>',
      productsMarkup,
      '</div>'
    ].join('');
  }

  function renderLoading() {
    return [
      '<div class="predictive-search-kronotime predictive-search-kronotime--loading">',
      '<div class="predictive-search-kronotime__loading">',
      '<span class="icon-predictive-search-spinner"></span>',
      '<span class="visually-hidden">' + escapeHtml(strings.loading) + '</span>',
      '</div>',
      '</div>'
    ].join('');
  }

  function buildSuggestions(data) {
    var suggestions = (data.queries || []).map(function (query) {
      return {
        text: query.text,
        url: query.url || buildSearchUrl(query.text)
      };
    });

    if (!suggestions.length && data.products && data.products.length) {
      suggestions = data.products.slice(0, 8).map(function (product) {
        var variant = product.variants && product.variants.length ? product.variants[0] : product;
        return {
          text: product.title,
          url: variant.url || product.url
        };
      });
    }

    return suggestions;
  }

  function kronotimeSearchTemplate(data) {
    if (data.isLoading && (!data.products || !data.products.length)) {
      return renderLoading();
    }

    var products = (data.products || []).slice(0, 10);
    var collections = (data.collections || []).slice(0, 8);
    var suggestions = buildSuggestions(data);
    var searchQuery = data.searchQuery || '';

    if (!hasSearchResults(data) && searchQuery) {
      return renderNoResultsState(searchQuery);
    }

    var hasSidebar = suggestions.length > 0 || collections.length > 0;
    var hasContent = hasSidebar || products.length > 0 || searchQuery;

    if (!hasContent) return '';

    return [
      '<div class="predictive-search-kronotime">',
      '<div class="predictive-search-kronotime__layout' +
        (hasSidebar ? '' : ' predictive-search-kronotime__layout--products-only') +
        '">',
      hasSidebar
        ? [
            '<aside class="predictive-search-kronotime__sidebar">',
            renderSuggestions(suggestions),
            renderCollections(collections),
            '</aside>'
          ].join('')
        : '',
      renderProducts(products, searchQuery),
      '</div>',
      '</div>'
    ].join('');
  }

  componentProto._handlePredictiveSearchSuccess = function (json) {
    clearTimeout(this._latencyTimer);
    this.results = json.resources.results;
    this.results.isLoading = false;
    this.results.products = (this.results.products || []).slice(0, this.numberOfResults);
    this.results.queries = this.results.queries || [];
    this.results.collections = this.results.collections || [];
    this.results.canLoadMore = this.numberOfResults <= this.results.products.length;
    this.results.searchQuery = this.nodes.input.value;

    var hasResults = hasSearchResults(this.results);

    if (hasResults || this.results.searchQuery) {
      this.nodes.result.innerHTML = this.resultTemplateFct(this.results);
      this._announceNumberOfResultsFound(this.results);
      this.open();

      if (window.lazySizes && typeof window.lazySizes.loader !== 'undefined') {
        window.lazySizes.loader.checkElems();
      }
    } else {
      this.nodes.result.innerHTML = '';
      this._closeOnNoResults();
    }
  };

  window.theme = window.theme || {};
  window.theme.SearchResultsTemplate = kronotimeSearchTemplate;

  window.Shopify.theme.PredictiveSearchComponent = function KronotimePredictiveSearchComponent(config) {
    config = config || {};
    config.PredictiveSearchAPIConfig = config.PredictiveSearchAPIConfig || KRONOTIME_API_CONFIG;
    config.numberOfResults = config.numberOfResults || 10;
    config.resultTemplateFct = kronotimeSearchTemplate;
    return new OriginalComponent(config);
  };
  window.Shopify.theme.PredictiveSearchComponent.prototype = componentProto;

  if (window.theme.SearchHeader) {
    var headerComponentInstance;

    window.theme.SearchHeader.init = function () {
      var searchInput = document.querySelector('[data-predictive-search-drawer-input]');
      var searchSubmit = document.querySelector('[data-search-form-submit]');

      if (!searchInput) return;

      window.theme.SearchHeader.unload();

      var searchUrl = searchInput.dataset.baseUrl;

      headerComponentInstance = new window.Shopify.theme.PredictiveSearchComponent({
        selectors: {
          input: '[data-predictive-search-drawer-input]',
          result: '[data-predictive-search-mount="drawer"]'
        },
        searchUrl: searchUrl,
        numberOfResultsTemplateFct: function (data) {
          if (data.products.length === 1) {
            return window.theme.strings.one_result_found;
          }
          return window.theme.strings.number_of_results_found.replace(
            '[results_count]',
            data.products.length
          );
        },
        loadingResultsMessageTemplateFct: function () {
          return window.theme.strings.loading;
        },
        onInputBlur: function () {
          return false;
        },
        onOpen: function (nodes) {
          nodes.result.classList.add('predictive-search-wrapper--visible');
          if (window.lazySizes && typeof window.lazySizes.loader !== 'undefined') {
            window.lazySizes.loader.checkElems();
          }
        },
        onClose: function (nodes) {
          nodes.result.classList.remove('predictive-search-wrapper--visible');
        }
      });

      if (searchSubmit) {
        searchSubmit.addEventListener('click', function (evt) {
          if (searchInput.value.trim().length === 0) {
            evt.preventDefault();
            searchInput.focus();
          }
        });
      }
    };

    window.theme.SearchHeader.unload = function () {
      if (headerComponentInstance) {
        headerComponentInstance.destroy();
        headerComponentInstance = null;
      }
    };

    window.theme.SearchHeader.clearAndClose = function () {
      if (headerComponentInstance) {
        headerComponentInstance.clearAndClose();
      }
    };
  }

  function initSearchPageForm() {
    var searchForm = document.querySelector('.search-page-form');
    var searchInput = document.querySelector('[data-search-page-search-input]');
    var searchSubmit = document.querySelector('[data-search-page-search-submit]');

    if (!searchForm || !searchInput || searchForm.dataset.searchPageInit === 'true') return;

    searchForm.dataset.searchPageInit = 'true';

    function validateSearchInput(evt) {
      if (searchInput.value.trim().length > 0) return;
      if (evt) evt.preventDefault();
      searchInput.focus();
    }

    searchForm.addEventListener('submit', validateSearchInput);

    if (searchSubmit) {
      searchSubmit.addEventListener('click', validateSearchInput);
    }
  }

  if (window.theme.SearchPage) {
    window.theme.SearchPage.init = function () {
      initSearchPageForm();
    };

    window.theme.SearchPage.unload = function () {};
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearchPageForm);
  } else {
    initSearchPageForm();
  }

  if (window.theme.SearchDrawer) {
    var originalSearchDrawerInit = window.theme.SearchDrawer.init;

    window.theme.SearchDrawer.init = function () {
      originalSearchDrawerInit.call(window.theme.SearchDrawer);

      var drawer = document.getElementById('SearchDrawer');
      if (drawer) {
        drawer.style.height = '';
      }
    };

    document.addEventListener('click', function (event) {
      if (!event.target.closest('[data-predictive-search-open-drawer], .js-drawer-open-top')) return;

      window.setTimeout(function () {
        var drawer = document.getElementById('SearchDrawer');
        if (drawer) drawer.style.height = '';
      }, 0);
    });
  }
})();
